import React from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { CSSTransition, TransitionGroup, } from 'react-transition-group';
import { Toast } from '@@Components/Toast';
const notificationsSelector = (state) => state.notifications;
export const NotificationsWrapper = styled.div `
  position: fixed;
  left: 40px;
  bottom: 40px;
  width: 100%;
  z-index: 1500;
  max-width: 330px;
  pointer-events: none;
`;
export const Notifications = () => {
    const notifications = useSelector(notificationsSelector);
    return (React.createElement(NotificationsWrapper, null,
        React.createElement(TransitionGroup, null, notifications.map((notification, key) => (React.createElement(CSSTransition, { key: key, timeout: 500, classNames: "notification" },
            React.createElement(Toast, { id: notification.id, type: notification.type }, notification.message)))))));
};
